import { z } from "zod";

/**
 * Skema untuk keseluruhan respons dari endpoint DELETE /group/{id}.
 * Endpoint ini biasanya hanya mengkonfirmasi bahwa operasi penghapusan berhasil
 * dan tidak mengembalikan data dari entitas yang telah dihapus.
 */
export const DeleteGroupResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    // Karena entitas telah dihapus, respons tidak mengandung data.
    // Oleh karena itu, kita secara eksplisit memvalidasi bahwa field 'data'
    // bernilai 'null' untuk memastikan kontrak API dipenuhi.
    data: z.null(),
});

// Mengekspor tipe data TypeScript yang di-infer dari skema Zod.
export type DeleteGroupResponse = z.infer<typeof DeleteGroupResponseSchema>;